import { useCallback, useState } from 'react'

export interface DialogState {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
}

export interface UseComingSoonDialogsReturn {
  toolsDialog: DialogState
  handleToolsClick: () => void
}

export const useComingSoonDialogs = (): UseComingSoonDialogsReturn => {
  const [isToolsDialogOpen, setIsToolsDialogOpen] = useState(false)

  const handleToolsClick = useCallback(() => {
    setIsToolsDialogOpen(true)
  }, [])

  return {
    toolsDialog: {
      isOpen: isToolsDialogOpen,
      onOpenChange: setIsToolsDialogOpen,
    },
    handleToolsClick,
  }
}
